import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  container: {
    backgroundColor: '#D0FCF4',
    fontFamily: 'Montserrat',
    overflowX: 'hidden'
  },
  paragraph: {
    fontSize: 20,
    fontWeight: 500
  },
  footer: {
    width: '100%',
    padding: '2vw',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '0.8rem'
  },
})